import { AlertTriangle, Inbox, LoaderCircle } from 'lucide-react'

export function StatePanel({ type = 'empty', title, message }) {
  const Icon = type === 'loading' ? LoaderCircle : type === 'error' ? AlertTriangle : Inbox
  return (
    <div className={`state-panel state-panel--${type}`} role={type === 'error' ? 'alert' : 'status'}>
      <Icon aria-hidden="true" />
      <div><h3>{title}</h3><p>{message}</p></div>
    </div>
  )
}
